import React, { useContext, useEffect, useMemo } from 'react';
import styles from './StickyPortal.module.scss';
import { createPortal } from 'react-dom';
import throttle from '../utils/throttle';
import FacultyXPViewContext from '../FacultyXPViewContext/FacultyXPViewContext';
function insertAfter(sticksToEl, containerEl) {
  sticksToEl.parentNode.insertBefore(containerEl, sticksToEl.nextSibling);
}
export default function StickyPortal(_ref) {
  var _ref$adjust = _ref.adjust,
    adjust = _ref$adjust === void 0 ? 0 : _ref$adjust,
    children = _ref.children,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? null : _ref$id,
    sticksTo = _ref.sticksTo;
  var facultyXP = useContext(FacultyXPViewContext);
  var containerEl = useMemo(function () {
    var el = document.createElement('div');
    el.classList.add(facultyXP ? styles.container : styles.legacyContainer);
    if (id) {
      el.id = id;
    }
    return el;
  }, [id, facultyXP]);
  useEffect(function () {
    var sticksToEl = document.querySelector(sticksTo);
    insertAfter(sticksToEl, containerEl);
    var computeTop = throttle(function () {
      var _sticksToEl$getBoundi = sticksToEl.getBoundingClientRect(),
        height = _sticksToEl$getBoundi.height;
      var top = adjust + height + parseInt(getComputedStyle(sticksToEl).top);
      containerEl.style.top = "".concat(top, "px");
    }, 100);
    computeTop();
    window.addEventListener('resize', computeTop, false);
    return function () {
      containerEl.remove();
      window.removeEventListener('resize', computeTop);
    };
  }, [sticksTo, containerEl, adjust]);
  return createPortal(children, containerEl);
}